module.exports = __webpack_public_path__ + "img/shoucang.97e651c7.png";